// Find the position of the closing ')' that matches the opening '(' for (Label: ...), so value can contain ) inside HTML/rgb()
export const findMatchingCloseParen = (str, startAfterOpen) => {
    let depth = 1;
    let i = startAfterOpen;
    while (i < str.length) {
        const c = str[i];
        if (c === '<') {
            const close = str.indexOf('>', i + 1);
            if (close === -1) break;
            i = close + 1;
            continue;
        }
        if (c === '"' || c === "'") {
            const q = c;
            i += 1;
            while (i < str.length && str[i] !== q) {
                if (str[i] === '\\') i += 1;
                i += 1;
            }
            if (i < str.length) i += 1;
            continue;
        }
        if (c === '(') { depth += 1; i += 1; continue; }
        if (c === ')') {
            depth -= 1;
            if (depth === 0) return i;
            i += 1;
            continue;
        }
        i += 1;
    }
    return -1;
};

// Removes round brackets from fixed words (Victim, Offender, Witness) and label patterns (e.g. (DOB: value), (Loss Code: value)) in report notes.
// Label values may contain HTML (e.g. <span style="...">) so we find the matching closing ) to avoid breaking rgb() or tags.
export const removeNoteRoundBrackets = (text) => {
    if (!text || typeof text !== 'string') return text;
    let result = text;
    // Fixed words: (Victim) -> Victim, (Offender) -> Offender, (Witness) -> Witness
    result = result.replace(/\s*\(\s*Victim\s*\)/g, ' Victim ');
    result = result.replace(/\s*\(\s*Offender\s*\)/g, ' Offender ');
    result = result.replace(/\s*\(\s*Witness\s*\)/g, ' Witness ');
    // Label patterns: (Label: value) -> Label: value (value can contain HTML, rgb(), etc.)
    const labels = ['Loss Code', 'Victim Type', 'DOB', 'Age', 'Race', 'Gender', 'Ethnicity', 'Resident', 'Category', 'Plate Type', 'Plate State', 'Plate No', 'VIN'];
    labels.forEach((label) => {
        const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const openRegex = new RegExp(`\\(\\s*${escaped}\\s*:\\s*`, 'gi');
        let match;
        while ((match = openRegex.exec(result)) !== null) {
            const startOpen = match.index;
            const startValue = startOpen + match[0].length;
            const closeIdx = findMatchingCloseParen(result, startValue);
            if (closeIdx === -1) {
                openRegex.lastIndex = startValue;
                continue;
            }
            const value = result.slice(startValue, closeIdx).trim();
            const replacement = ` ${label}: ${value} `;
            result = result.slice(0, startOpen) + replacement + result.slice(closeIdx + 1);
            openRegex.lastIndex = 0;
        }
    });
    return result;
};

// When Status is Approved, remove (MNI:...) from text – sensitive info not shown in display or print
export const removeMniWhenApproved = (text) => {
    if (!text || typeof text !== 'string') return text;
    return text.replace(/\(MNI:[^)]*\)/g, '').replace(/\s{2,}/g, ' ').trim();
};

// Remove blue color and underline from notes in Master Incident Report (e.g. name links)
export const removeBlueAndUnderlineFromNotes = (html) => {
    if (!html || typeof html !== 'string') return html;
    let result = html;
    result = result.replace(/color:\s*(?:#007bff|rgb\s*\(\s*0\s*,\s*123\s*,\s*255\s*\))/gi, 'color: #434A54');
    // result = result.replace(/<u\s[^>]*>/gi, '');
    // result = result.replace(/<\/u>/gi, '');
    return result;
};
